module.exports = __webpack_public_path__ + "img/pay-chat-selected.c91b4e6d.png";